import React from "react";
import {
  CreateButton,
  Datagrid,
  List,
  Pagination,
  TextField,
  TextInput,
  TopToolbar,
  type ListProps,
} from "react-admin";
import Box from "@mui/material/Box";
import CustomEmpty from "@/components/custom-empty";
import { FmbDishCsvImportButton } from "./FmbDishCsvImportButton";

const filters = [
  <TextInput
    key="q"
    source="q"
    label="Search name or description"
    alwaysOn
    sx={{ minWidth: 280 }}
  />,
];

const ListActions = () => (
  <TopToolbar>
    <FmbDishCsvImportButton />
    <CreateButton />
  </TopToolbar>
);

const emptyActions = (
  <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", justifyContent: "center" }}>
    <FmbDishCsvImportButton />
    <CreateButton variant="contained" />
  </Box>
);

export default function FmbDishList(props: ListProps) {
  return (
    <List
      {...props}
      title="Dishes"
      perPage={50}
      sort={{ field: "name", order: "ASC" }}
      filters={filters}
      pagination={<Pagination rowsPerPageOptions={[10, 25, 50, 100]} />}
      actions={<ListActions />}
      empty={
        <CustomEmpty
          title="No dishes yet"
          subtitle="Create one, or download the CSV template and import many at once."
          action={emptyActions}
        />
      }
    >
      <Datagrid bulkActionButtons={false} rowClick="edit">
        <TextField source="name" />
        <TextField source="dietaryType" label="Dietary" />
      </Datagrid>
    </List>
  );
}
